import axiosClient from './axiosClient';

export interface RoleDTO {
  id: string;
  name: string;
  display_name?: string;
}

export const roleAPI = {
  async getPublicRoles(): Promise<RoleDTO[]> {
    const res = await axiosClient.get<RoleDTO[]>('/roles/public');
    return res.data || [];
  },
  async getAllRoles(): Promise<RoleDTO[]> {
    const res = await axiosClient.get<RoleDTO[]>('/roles');
    return res.data || [];
  },
};
